import { RootActions } from 'store/redux';
import { OrdersTabParentState } from 'types/enums/OrdersTabParentState';
import { OrdersTabState } from 'types/enums/OrdersTabState';
import { DashboardActions } from '../actions/dashboardActions';
import { DashboardState, dashboardState } from '../states/dashboardState';

const dashboardReducer = (state = dashboardState, action: RootActions): DashboardState => {
  switch (action.type) {
    case DashboardActions.CHANGE_DASHBOARD_PARENT_TAB: {
      const newState = {
        ...state,
        dashboard_orders: null,
        dashboardOrderFilter: null,
        searchParams: null,
        activeOrderId: null,
        pageSize: 10,
        currentPage: 0,
        sortKpiMetricGridData: undefined,
        pageHandler: {
          ...state.pageHandler,
          parentTab: action.payload.tab ?? state.pageHandler.parentTab,
        },
      };

      return newState;
    }

    case DashboardActions.SET_DASHBOARD_ACTIVE_ORDERID: {
      const newState = {
        ...state,
        activeOrderId: action.payload.orderId,
      };

      return newState;
    }
    case DashboardActions.SORT_ORDER_DASHBOARD:
      return {
        ...state,
        sortDashboardTodoOrder: action.payload,
      };

    case DashboardActions.DASHBOARD_ORDERS:
      return {
        ...state,
        dashboard_orders: action.payload.dashboard_orders,
        pageHandler: {
          ...state.pageHandler,
          totalPages: action.payload.totalPages,
          currentPage: action.payload.currentPage || state.pageHandler.currentPage,
          totalItems: action.payload.totalItems,
        },
      };

    case DashboardActions.CHANGE_DASHBOARD_SEARCH_PARAMS_MANAGEMENT:
      return {
        ...state,
        searchParams: action.payload,
      };
    case DashboardActions.SET_DASHBOARD_ACTIVE_LAST_ORDERID: {
      return {
        ...state,
        activeLastOrderId: action.payload.orderId,
      };
    }
    case DashboardActions.SET_DASHBOARD_ACTIVE_SCROLL_ORDERID: {
      return {
        ...state,
        offsetTop: action.payload.offsetTop,
      };
    }
    case DashboardActions.GET_DASHBOARD_ORDER_FILTER: {
      return {
        ...state,
        dashboardOrderFilter: action.payload,
      };
    }
    case DashboardActions.CHANGE_PAGE_SIZE:
      return {
        ...state,
        pageSize: action.payload,
      };
    case DashboardActions.CHANGE_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };
    case DashboardActions.KPIMETRICGRID_DATA:
      return {
        ...state,
        kpiMetricGridData: action.payload.kpiMetricGridData,
        pageHandler: {
          ...state.pageHandler,
          totalPages: action.payload.totalPages,
          currentPage: action.payload.currentPage || state.pageHandler.currentPage,
          totalItems: action.payload.totalItems,
        },
      };
    case DashboardActions.SORT_KPIMETRIC_GRID:
      return {
        ...state,
        sortKpiMetricGridData: action.payload,
      };
    case DashboardActions.TODO_CREATE_ORDER_SCREEN:
      return {
        ...state,
        todoOrderCreateList: action.payload,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
